// store/modules/valuation.js
import { loadState, saveState } from '../../../libs/persist';

const STORE_KEY = 'valuation';

// Load persisted state safely
const persisted = loadState(STORE_KEY);

// Always initialize as array
const state = {
	valuationData: (persisted && persisted.valuationData) || [],
};

const mutations = {
	SET_VALUATION_DATA(state, data) {
		// Always store as array
		const payload = Array.isArray(data) ? data : data ? [data] : [];
		state.valuationData = payload;

		// Persist only the part we care about (avoid saving full state object)
		saveState(STORE_KEY, { valuationData: payload });
	},
};

const actions = {
	setValuationData({ commit }, data) {
		commit('SET_VALUATION_DATA', data);
	},

	// Optional: clear valuation data (useful on logout)
	clearValuationData({ commit }) {
		commit('SET_VALUATION_DATA', []);
	},
};

const getters = {
	// THIS WAS THE MAIN BUG → you returned state.riskData (doesn't exist!)
	selectValuationData: (state) => state.valuationData || [],

	// Optional helpers
	selectValuationRequest: (state) => state.valuationData[0] || null,
	hasValuationData: (state) =>
		Array.isArray(state.valuationData) && state.valuationData.length > 0,
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
